import ValueX from '../types/ValueX';

export default class AbatementX extends ValueX {
    static __className = 'AbatementX';

    constructor(constructJson) {
        super(constructJson, 'abatement', 'AbatementX');
    }
}
